import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import IconBox from '../icon-box';
import IconBoxGridTheme from './theme';
/*::
import type { Node } from 'react';
import type { IconBoxGridThemeType } from './theme';

export type Item = {|
  iconSrc: string,
  iconAlt: string,
  label?: string,
  text?: string,
|}

export type Props = {|
  items?: Item[],
  boxType?: 'LargeFixedHeight'
    | 'LargeWithText'
    | 'NarrowWithText'
    | 'Medium'
    | 'Small',
  theme?: IconBoxGridThemeType,
  rest?: any,
|}
*/

var IconBoxGrid = function IconBoxGrid(_ref
/*: Props */
) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      boxType = _ref.boxType,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? IconBoxGridTheme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["items", "boxType", "theme"]);

  var getBoxTheme = function getBoxTheme(type) {
    if (type === 'LargeFixedHeight') {
      return theme.IconBoxLargeFixedHeight;
    }

    if (type === 'NarrowWithText') {
      return theme.IconBoxNarrowWithText;
    }

    if (type === 'Medium') {
      return theme.IconBoxMedium;
    }

    if (type === 'Small') {
      return theme.IconBoxSmall;
    }

    return theme.IconBoxLargeWithText;
  };

  return /*#__PURE__*/React.createElement(theme.Main, rest, items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(IconBox // eslint-disable-next-line
    , {
      key: idx,
      iconSrc: item.iconSrc,
      iconAlt: item.iconAlt,
      label: item.label,
      text: item.text,
      theme: getBoxTheme(boxType)
    });
  }));
};

export default IconBoxGrid;